import axios from "axios";
import constants from "@/assets/js/constants";

var chunkSize = 1024 * 1024;
let isStopedChunkUploading = false;

const uploadChunkService = async (file, { onProgress = () => { }, onComplete = () => { }, onError = () => { }, onAbort = () => { } }) => {

    if (file == null || file == undefined)
        onError('');

    const totalChunks = Math.ceil(file.size / chunkSize);
    const name = file.name.substring(0, file.name.lastIndexOf('.'));
    const tempId =generateGUID();
    const fileName =name +tempId;

    const fileExtension = file.name.split('.').pop();
    let uploadedChunks = 0;
    isStopedChunkUploading = false;

    try {
        for (let start = 0; start < file.size; start += chunkSize) {

            if (isStopedChunkUploading == true) {
                onAbort(fileName);
                break;
            }

            const chunk = file.slice(start, start + chunkSize);
            const chunkIndex = uploadedChunks;

            const formData = new FormData();
            formData.append('Chunk', chunk);
            formData.append('FileName', fileName);
            formData.append('FileExtension', fileExtension);
            formData.append('ChunkIndex', chunkIndex);
            formData.append('TotalChunks', totalChunks);
            formData.append('ChunkTempId', tempId);


            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + localStorage.getItem('user')
            };

            const response = await axios.post(`${constants.baseApiUrl}Attachment/UploadChunk`, formData, { headers });

            if (response?.data?.isSuccess) {
                uploadedChunks++;
                onProgress(Math.floor((uploadedChunks / totalChunks) * 100));

                if (response.data.isCompleted) {
                    onProgress(100);
                    onComplete(response.data.uploadChunkTempId);
                    break;
                }
            } else {
                onError(tempId,response.data.message);
                break;
            }
        }
    } catch (error) {
        console.error('Error during file upload:', error);
        onError(tempId,"Error during file upload");
    }
};

const stopChunkUploading = () => {
    isStopedChunkUploading = true;
}
const deleteChunkUploading = (uploadChunkTempId) => {

    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + localStorage.getItem('user')
    };
    axios.get(constants.baseApiUrl + 'Attachment/DeleteChunkTempFile?uploadChunkTempId=' + uploadChunkTempId, headers)
        .then(response => {

        })
        .catch(error => { })
        .finally(() => { })

}
const generateGUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0;
        const value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
    });
};

export default {
    uploadChunkService, stopChunkUploading, deleteChunkUploading
};

